// extracted by mini-css-extract-plugin
export default {"wrapper":"appLayout_wrapper__arRX1","mainSection":"appLayout_mainSection__HNlCM","content":"appLayout_content__MswDz"};